import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CandleValidation } from 'client/voladeum/candle-validations/types';
import { SLICE } from 'ducks/slice';

import { EMPTY_ARRAY } from '../../constants';

const initialState: CandleValidation[] = EMPTY_ARRAY;

export const candleValidationsSlice = createSlice({
  name: SLICE.CANDLE_VALIDATIONS,
  initialState,
  reducers: {
    setCandleValidations: (_state, action: PayloadAction<CandleValidation[]>) => {
      return action.payload;
    },
    clearValidations: () => {
      return initialState;
    },
  },
});

export const { setCandleValidations, clearValidations } = candleValidationsSlice.actions;

export default candleValidationsSlice.reducer;
